"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Local;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _util = require("util");
const _stream = require("stream");
const _mkdirp = /*#__PURE__*/ _interop_require_default(require("mkdirp"));
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _requestfilteringagent = require("request-filtering-agent");
const _glob = require("glob");
const _common = require("@nestjs/common");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Local = class Local {
    async fileCreate(key, file) {
        const destPath = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(key);
        try {
            await (0, _mkdirp.default)(_path.default.dirname(destPath));
            const data = await (0, _util.promisify)(_fs.default.readFile)(file.path);
            await (0, _util.promisify)(_fs.default.writeFile)(destPath, data);
            await (0, _util.promisify)(_fs.default.unlink)(file.path);
        // await fs.promises.rename(file.path, destPath);
        } catch (e) {
            _ncError.NcError._.storageFileCreateError(e.message);
        }
    }
    async fileCreateByUrl(key, url, { fetchOptions: { buffer } = {
        buffer: false
    } }) {
        try {
            const destPath = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(key);
            const response = await _axios.default.get(url, {
                responseType: buffer ? 'arraybuffer' : 'stream',
                headers: {
                    accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
                    'accept-language': 'en-US,en;q=0.9',
                    'cache-control': 'no-cache',
                    pragma: 'no-cache',
                    'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36',
                    origin: 'https://www.airtable.com/'
                },
                httpAgent: (0, _requestfilteringagent.useAgent)(url),
                httpsAgent: (0, _requestfilteringagent.useAgent)(url)
            });
            await (0, _mkdirp.default)(_path.default.dirname(destPath));
            if (buffer) {
                await _fs.default.promises.writeFile(destPath, Buffer.from(response.data));
                return {
                    url: null,
                    data: response.data
                };
            } else {
                await this.fileCreateByStream(key, response.data);
                return {
                    url: null,
                    data: null
                };
            }
        } catch (err) {
            _ncError.NcError._.storageFileCreateError(`Failed to create file from URL: ${err.message}`);
        }
    }
    async fileCreateByStream(key, stream) {
        const destPath = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(key);
        try {
            await (0, _mkdirp.default)(_path.default.dirname(destPath));
            await new Promise((resolve, reject)=>{
                const writableStream = _fs.default.createWriteStream(destPath);
                writableStream.on('finish', ()=>resolve());
                writableStream.on('error', reject);
                stream.on('error', reject);
                stream.pipe(writableStream);
            });
            // Verify file was written successfully
            await this.fileRead(destPath);
            return null;
        } catch (e) {
            _ncError.NcError._.storageFileStreamError(e.message);
        }
    }
    async fileReadByStream(key, options) {
        try {
            const srcPath = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(key);
            // Check if file exists before creating stream
            await _fs.default.promises.access(srcPath, _fs.default.constants.R_OK);
            return _fs.default.createReadStream(srcPath, _extends({}, (options == null ? void 0 : options.encoding) && {
                encoding: options.encoding
            }));
        } catch (e) {
            _ncError.NcError._.storageFileStreamError(e.message);
        }
    }
    async getDirectoryList(key) {
        try {
            const destDir = (0, _attachmentHelpers.validateAndNormaliseLocalPath)(key);
            return await _fs.default.promises.readdir(destDir);
        } catch (e) {
            _ncError.NcError._.storageFileReadError(`Failed to list directory: ${e.message}`);
        }
    }
    async fileDelete(path) {
        try {
            return await _fs.default.promises.unlink((0, _attachmentHelpers.validateAndNormaliseLocalPath)(path));
        } catch (e) {
            _ncError.NcError._.storageFileDeleteError(e.message);
        }
    }
    async fileRead(filePath) {
        try {
            const fileData = await _fs.default.promises.readFile((0, _attachmentHelpers.validateAndNormaliseLocalPath)(filePath, true));
            return fileData;
        } catch (e) {
            _ncError.NcError._.storageFileReadError(e.message);
        }
    }
    async scanFiles(globPattern) {
        try {
            // Normalize the path separator
            globPattern = globPattern.replace(/\//g, _path.default.sep);
            // remove all dots from the glob pattern
            globPattern = globPattern.replace(/\./g, '');
            // remove the leading slash
            globPattern = globPattern.replace(/^\//, '');
            // Ensure the pattern starts with 'nc/uploads/'
            if (!globPattern.startsWith(_path.default.join('nc', 'uploads'))) {
                globPattern = _path.default.join('nc', 'uploads', globPattern);
            }
            const globStreamInstance = (0, _glob.globStream)(globPattern, {
                nodir: true
            });
            const stream = _stream.Readable.from(globStreamInstance);
            // Forward errors from glob stream
            globStreamInstance.on('error', (error)=>{
                stream.destroy(error);
            });
            return stream;
        } catch (e) {
            _ncError.NcError._.storageFileReadError(`Failed to scan files: ${e.message}`);
        }
    }
    init() {
        return Promise.resolve(undefined);
    }
    test() {
        return Promise.resolve(false);
    }
    getUploadedPath(filePath) {
        const usePath = filePath.startsWith('/') ? filePath.replace(/^\/+/, '') : filePath;
        return {
            path: _path.default.join('download', usePath)
        };
    }
    constructor(){
        this.name = 'Local';
        this.logger = new _common.Logger(Local.name);
    }
};
